import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';

import { serverStatus } from '@app/services/__global__/serverStatus';
import { useTopBannerOffset } from '@app/shared/hooks';

import './styles/ServerMaintenanceBanner.desktop.scss';

const ROOT_CLASS = 'bc-server-maintenance-banner';
const { Text } = Typography;

export const ServerMaintenanceBanner = () => {
  const [serverDown, setServerDown] = useState(serverStatus.isDown);
  const [dismissed, setDismissed] = useState(false);
  const [animating, setAnimating] = useState(false);
  const bannerRef = useRef<HTMLDivElement>(null);

  const show = serverDown && !dismissed;

  // Сдвигаем лейаут вниз, чтобы баннер не перекрывал верх сайдбара
  useTopBannerOffset('server-maintenance', bannerRef, show);

  useEffect(() => {
    return serverStatus.subscribe((isDown) => {
      setServerDown(isDown);
      if (isDown) {
        setDismissed(false);
      }
    });
  }, []);

  useEffect(() => {
    setAnimating(show);
  }, [show]);

  const handleClose = useCallback(() => {
    setAnimating(false);
    setTimeout(() => setDismissed(true), 300);
  }, []);

  if (!serverDown && dismissed) return null;
  if (!show && !animating) return null;

  return (
    <div
      ref={bannerRef}
      className={`${ROOT_CLASS} ${animating ? `${ROOT_CLASS}--visible` : ''}`}
    >
      <LoadingOutlined className={`${ROOT_CLASS}__icon`} />
      <Text className={`${ROOT_CLASS}__text`}>
        Сервер недоступен на несколько секунд из-за установки обновлений.
      </Text>
      <button
        type="button"
        className={`${ROOT_CLASS}__close`}
        onClick={handleClose}
      >
        <CloseOutlined />
      </button>
    </div>
  );
};
